import { render, staticRenderFns } from "./ColorCurriculumUnitBox.vue?vue&type=template&id=07e89364&scoped=true&lang=pug&"
import script from "./ColorCurriculumUnitBox.vue?vue&type=script&lang=ts&"
export * from "./ColorCurriculumUnitBox.vue?vue&type=script&lang=ts&"
import style0 from "./ColorCurriculumUnitBox.vue?vue&type=style&index=0&id=07e89364&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e89364",
  null
  
)

export default component.exports